import type { TeammateAccountCallOutline } from "@repo/app-types/entities/teammateAccountCallOutline";
import { DateTime } from "luxon";
import type { CallPosition } from "./teammateAccountCallOutlineNavigation.js";

interface BuildCallOutlineTriggerLabelArgs {
  callOutline: TeammateAccountCallOutline | undefined;
  callPosition: CallPosition | undefined;
}

export function buildCallOutlineTriggerLabel(
  args: BuildCallOutlineTriggerLabelArgs,
): string {
  const { callOutline, callPosition } = args;
  const fallbackLabel = "Select section";
  const fallbackCall = callOutline?.calls[0];

  if (!fallbackCall) {
    return fallbackLabel;
  }

  const activeCall =
    (callPosition
      ? callOutline?.calls.find(
          (candidateCall) =>
            candidateCall.recording_id === callPosition.recordingId,
        )
      : undefined) ?? fallbackCall;

  const activeSegment =
    activeCall.recording_id === callPosition?.recordingId
      ? activeCall.segments.find(
          (segment) =>
            callPosition.timestamp >= segment.start_timestamp &&
            callPosition.timestamp < segment.end_timestamp,
        )
      : undefined;

  const summary = activeSegment?.title ?? activeCall.title ?? fallbackLabel;
  const recordedAtLabel = formatCallRecordedAt(activeCall.recorded_at);

  return recordedAtLabel ? `${recordedAtLabel} · ${summary}` : summary;
}

export function formatCallRecordedAt(recordedAt: string): string {
  const dateTime = DateTime.fromISO(recordedAt);
  if (!dateTime.isValid) {
    return "";
  }

  return dateTime.toFormat("LLL d, yyyy");
}
